export const ENDPOINTS = {
  DASHBOARD_STATS: '/dashboard/stats',
};
